import {AxiosResponse} from 'axios';
import {axiosInstance} from '../..';


export function getVisits(id: string): Promise<AxiosResponse<any, any>> {
  return axiosInstance.get(`Visit`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function getVisitId(id: string): Promise<AxiosResponse<any, any>> {
    return axiosInstance.get(`Visit/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
}

export function createVisit(data: any): Promise<AxiosResponse<any, any>> {
  return axiosInstance.post('Visit', data, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function updateVisitId(id: string, data: any): Promise<AxiosResponse<any, any>> {
  return axiosInstance.put(`Visit/${id}`, data, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}
export function deleteVisitId(id: string): Promise<AxiosResponse<any, any>> {
  return axiosInstance.delete(`Visit/${id}`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

